export interface IQuery { }

export class TchScaleTemplatesListQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Scales.Queries.TchScaleTemplatesListQueryV1, TCh.Domain.Scales'

	WorkspaceId: number

	constructor (workspaceId: number)
	{
		this.WorkspaceId = workspaceId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Scales.Queries.TchScaleTemplatesListQueryV1, TCh.Domain.Scales'
	}

}

export class WorkspaceScalesListQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Scales.Queries.WorkspaceScalesListQueryV1, TCh.Domain.Scales'

	WorkspaceId: number

	constructor (workspaceId: number)
	{
		this.WorkspaceId = workspaceId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Scales.Queries.WorkspaceScalesListQueryV1, TCh.Domain.Scales'
	}

}

